/**
 * Cleans up the query parameters in the
 * authentication redirect URL.
 */
export const cleanupAuthQueryParams = (): void => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  params.delete('code');
  params.delete('state');
  url.search = params.toString();
  window.history.replaceState({}, '', url.toString());
};
